((w) => {

    const assetId = 'gtm-eec-prod-view';

    let userInfo = null;
    if (w.umwAssets && w.umwAssets[assetId] && w.umwAssets[assetId].length) {
        userInfo = w.umwAssets[assetId][0];
    }

    const utils = new GtmUtils();

    w.PubSub.subscribe('externaltracking.product.detailsview', (_, trackableProduct) => {
        if (!trackableProduct) { return; }

        const gtmProduct = utils.convertToGtmEecProduct(trackableProduct);

        if (!gtmProduct) { return; }

        const productViewEvent = {
            'event': 'eec.productView',
            'ecommerce': {
                'currencyCode': utils.getCurrencyCode(trackableProduct),
                'detail': {
                    'products': [gtmProduct]
                }
            }
        };

        if (userInfo) {
            productViewEvent.user = userInfo;
        }

        w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        w.dataLayer.push(productViewEvent);
    });
})(window);